import { render, staticRenderFns } from "./board-statistics1.vue?vue&type=template&id=3c6d47e6&scoped=true&"
import script from "./board-statistics1.vue?vue&type=script&lang=js&"
export * from "./board-statistics1.vue?vue&type=script&lang=js&"
import style0 from "./board-statistics1.vue?vue&type=style&index=0&id=3c6d47e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d47e6",
  null
  
)

export default component.exports